import { fetchUser } from './fetchUser';
import { TContext } from '../types/context';

export enum EProbeStatus {
  /** Монолит подтвердил авторизацию */
  Authenticated = 'authenticated',
  /** Монолит ответил, что пользователь не авторизован */
  Anonymous = 'anonymous',
  /** Проверка не состоялась, выводы делать нельзя */
  Failed = 'failed',
}

export type TUserAuthenticationProbe = {
  status: EProbeStatus;
  userId: number | null;
};

let isProbeStarted = false;

/* istanbul ignore next */
export function resetUserAuthenticationProbeForTests(): void {
  isProbeStarted = false;
}

/**
 * Один раз за загрузку страницы спрашивает у монолита, авторизован ли пользователь на самом деле.
 * Нужен, чтобы отличить протухшую сессию от других причин отказа публичных ручек.
 * Возвращает null, если проверка не выполнялась
 */
export async function probeUserAuthentication(
  context: TContext,
  subdomain: string,
): Promise<TUserAuthenticationProbe | null> {
  if (typeof window === 'undefined' || isProbeStarted) {
    return null;
  }

  isProbeStarted = true;

  try {
    const user = await fetchUser(context, { subdomain, throwOnError: true });

    return {
      status: user.isAuthenticated ? EProbeStatus.Authenticated : EProbeStatus.Anonymous,
      userId: user.userId || null,
    };
  } catch {
    return { status: EProbeStatus.Failed, userId: null };
  }
}
